import React, { forwardRef } from "react";
import classes from "./ScrollLTR.module.css"

const ScrollLTR = forwardRef(({ dropClass, height, downDropStyle, children, dataStyle, onScrollFunc }, ref) => {


    return <div ref={ref} onScroll={onScrollFunc} style={{ height: height }} className={`${classes.Scroll} ${dropClass}`} data-style={dataStyle}>
        <div className={`${classes.RTL} ${downDropStyle}`} >
            {children}
        </div>
    </div >
})

export default ScrollLTR;